module.exports = __webpack_public_path__ + "assets/layers_white.ca4634b1.svg";